<div class="root" (click)="getVideoMetadata(); player.open()">
    <ng-content></ng-content>
</div>

<vimeo-video-player #player [metaData]="metaData">
</vimeo-video-player>
